module.exports = ".myClass :hover{\r\n    box-shadow: rgba(31, 31, 32, 0.35) 1px 10px 20px;\r\n    background-color: darkorange;\r\n}"